// @ts-strict-ignore
import { Drawer, DrawerSize } from '@blueprintjs/core'
import React from 'react'

export const PlaceholderDrawer = ({ open, setOpen, title, asin }) => {
    return (
        <Drawer
            canEscapeKeyClose
            canOutsideClickClose
            onClose={() => setOpen(false)}
            isOpen={open}
            size={DrawerSize.SMALL}
        >
            <div className="p-4 overflow-y-auto">
                <div className="font-normal text-xl mb-3">Templates</div>
                <div>
                    Templates give you an easy way to name your campaigns. Templates are setup using
                    a series of variables or placeholders, which are then replaced with their actual
                    values to create your campaign name.
                </div>
                <div>Quick Create currently supports 8 different variables.</div>
                <VariableDescription code="{{asin}}">
                    <div>This will be replaced with your ASIN (ie {asin})</div>
                </VariableDescription>
                <VariableDescription code="{{title}}">
                    <div>This will be replaced with your product's title (ie {title})</div>
                </VariableDescription>
                <VariableDescription code="{{platform}}">
                    <div>
                        This will be the advertising platform. Possible values are
                        <ul>
                            <li>Sponsored Products</li>
                            <li>Sponsored Brands</li>
                            <li>Sponsored Display</li>
                        </ul>
                    </div>
                </VariableDescription>
                <VariableDescription code="{{platform-short}}">
                    <div>
                        This will be replaced with the abbreviation for the advertising platform.
                        Possible values are
                        <ul>
                            <li>SP - for Sponsored Products</li>
                            <li>SB - for Sponsored Brands</li>
                            <li>SD - for Sponsored Display</li>
                        </ul>
                    </div>
                </VariableDescription>
                <VariableDescription code="{{type}}">
                    <div>
                        This will be replaced with the targeting type for this campaign. Possible
                        values are
                        <ul>
                            <li>Auto - for Auto targeting campaigns</li>
                            <li>Manual - for Manual targeting campaigns</li>
                        </ul>
                    </div>
                </VariableDescription>
                <VariableDescription code="{{type-short}}">
                    <div>
                        This will be replaced with the shortened targeting type for this campaign.
                        Possible values are
                        <ul>
                            <li>A - for Auto targeting campaigns</li>
                            <li>M - for Manual targeting campaigns</li>
                        </ul>
                    </div>
                </VariableDescription>
                <VariableDescription code="{{targeting}}">
                    <div>
                        This will be replaced with the targeting type for this ad group. Possible
                        values are
                        <ul>
                            <li>Keywords - for keyword targeting ad groups</li>
                            <li>Products - for product targeting ad groups</li>
                        </ul>
                    </div>
                </VariableDescription>
                <VariableDescription code="{{nickname}}">
                    <div>
                        This will be replaced with the nickname for the campaign. Possible values
                        are
                        <ul>
                            <li>Auto - for auto campaigns</li>
                            <li>Testing - for manual testing campaigns</li>
                            <li>Performance - for manual performance campaigns</li>
                        </ul>
                    </div>
                </VariableDescription>
            </div>
        </Drawer>
    )
}

const VariableDescription = ({ code, children }) => {
    return (
        <div className="mt-4">
            <code>{code}</code>
            {children}
        </div>
    )
}
